import { initializeApp } from 'firebase/app'
import {
  getFirestore,
  connectFirestoreEmulator,
  enableMultiTabIndexedDbPersistence
} from 'firebase/firestore'
import {
  getAuth,
  connectAuthEmulator,
  signInWithCredential,
  EmailAuthProvider
} from 'firebase/auth'

// the values to initialize the firebase app can be found in your firebase project
const firebaseConfig = {
  apiKey: 'AIzaSyDWKOIp-bn9xs0dme-noCkCXXmK7qa4rK0',
  authDomain: 'cobotfounder.firebaseapp.com',
  databaseURL: 'https://cobotfounder.firebaseio.com',
  projectId: 'cobotfounder',
  storageBucket: 'cobotfounder.appspot.com',
  messagingSenderId: '729590809640',
  appId: '1:729590809640:web:ca4058e673c120f480a11d'
}

const initFirebase = async () => {
  try {
    const app = initializeApp(firebaseConfig)
    const firestore = getFirestore(app)
    const auth = getAuth(app)

    // setup emulators
    if (process.env.NODE_ENV !== 'production') {
      connectAuthEmulator(auth, 'http://localhost:9099')
      connectFirestoreEmulator(firestore, 'localhost', 8080)
      enableMultiTabIndexedDbPersistence(firestore)
      signInWithCredential(
        auth,
        EmailAuthProvider.credential('john@doe.com', '123123')
      )
    }
  } catch (err) {
    console.error(err)
    return err
  }
}

export default initFirebase
